export const translations = {
  en: {
    appName: "CarTrack",
    tagline: "Live GPS tracking for your car",
    login: "Log in",
    signup: "Sign up",
    email: "Email",
    password: "Password",
    name: "Name",
    createAccount: "Create account",
    alreadyHave: "Already have an account?",
    noAccount: "Don't have an account?",
    logout: "Logout",
    home: "Home",
    trips: "Trips",
    alerts: "Alerts",
    settings: "Settings",
    geofences: "Geofences",
    connected: "Connected",
    disconnected: "Offline",
    currentSpeed: "Current speed",
    engineStatus: "Engine status",
    moving: "Moving",
    parked: "Parked",
    lastUpdated: "Last updated",
    todayDistance: "Today's distance",
    recenter: "Recenter",
    noInternet: "No internet connection",
    linkDevice: "Link your car device",
    deviceIdHelp:
      "Enter the Device ID shown on your car's CarTrack head-unit app to connect it to your account.",
    deviceId: "Device ID",
    carName: "Car name",
    link: "Link device",
    linked: "Device linked successfully",
    tripHistory: "Trip history",
    noTrips: "No trips yet. Start driving to see history.",
    duration: "Duration",
    distance: "Distance",
    start: "Start",
    end: "End",
    viewRoute: "View route",
    active: "Active",
    completed: "Completed",
    safeZones: "Safe zones",
    tapMapToPlace: "Tap the map to place a geofence",
    radius: "Radius",
    save: "Save",
    delete: "Delete",
    noGeofences: "No geofences yet.",
    noAlerts: "No alerts yet.",
    overspeed: "Overspeeding",
    geofenceEnter: "Entered zone",
    geofenceExit: "Left safe zone",
    markRead: "Mark as read",
    profileName: "Profile name",
    speedLimit: "Speed alert limit (km/h)",
    language: "Language",
    english: "English",
    hindi: "हिन्दी",
    version: "App version",
    signalStrength: "GPS signal",
    cartrackRunning: "CarTrack is running",
    headUnit: "Car head unit (simulated)",
    copyId: "Copy ID",
    copied: "Copied!",
    welcome: "Welcome back",
    getStarted: "Get started",
    or: "or",
    loading: "Loading…",
    saved: "Saved",
    demoHint: "Demo: demo@cartrack.in / demo1234",
    carLive: "Live car location",
    live: "LIVE",
    viewOnMap: "View on map",
    back: "Back",
    placeGeofence: "Place a geofence",
    geofenceName: "Zone name",
    createGeofence: "Create geofence",
    unread: "Unread",
    allAlerts: "All",
    speedOver: "Speed",
    ignition: "Ignition",
    confirmDelete: "Delete this geofence?",
    yes: "Yes",
    cancel: "Cancel",
    shareLive: "Share live location",
    shareDesc: "Generate a 15-minute link anyone can open to see your car — no account needed.",
    create15Min: "Create 15-min link",
    create30Min: "Create 30-min link",
    copyLink: "Copy link",
    linkCopied: "Link copied!",
    expiresIn: "Expires in",
    revoke: "Revoke",
    activeLinks: "Active share links",
    noActiveLinks: "No active links",
    sharedCar: "Live car location",
    shareExpired: "This share link has expired",
    linkNotFound: "Link not found or invalid",
    minutesShort: "min",
    secondsShort: "sec",
    poweredBy: "Powered by CarTrack",
    sos: "SOS",
    sosTrigger: "Trigger SOS",
    sosConfirmTitle: "Send emergency SOS?",
    sosConfirmBody: "This will notify all your emergency contacts via Telegram with your live location link.",
    sosSending: "Sending SOS…",
    sosSent: "SOS sent to {n} contact(s)",
    sosNoContacts: "Add at least one emergency contact in Settings first.",
    sosHistory: "SOS history",
    emergencyContacts: "Emergency contacts",
    emergencyContactsHelp: "Save up to 3 contacts. One tap on SOS sends your live location to all of them on Telegram.",
    contactName: "Contact name",
    mobileNumber: "Mobile number",
    addContact: "Add contact",
    maxContactsReached: "You've added the maximum 3 contacts",
    whatsappLog: "WhatsApp outbox (DRY RUN)",
    whatsappLogHelp: "Messages that would have been sent. Add real WhatsApp API credentials to send for real.",
    dryRun: "DRY RUN",
    noMessages: "No messages yet.",
    reports: "Reports",
    weeklyReport: "Weekly Driver Report",
    weekRange: "Week of {s} – {e}",
    totalDistance: "Total distance",
    tripsCount: "Trips",
    overspeedEvents: "Overspeed events",
    topSpeed: "Top speed",
    avgSpeed: "Average speed",
    score: "Driving score",
    generateNow: "Generate this week's report",
    noReportsYet: "No weekly reports yet. Scheduler runs Sunday 9pm IST.",
    reportHistory: "History (last 4 weeks)",
    generated: "Generated",
    noDataWeek: "No driving this week",
    waitingTitle: "Waiting for your car to connect",
    waitingBody: "Once your CarTrack head-unit sends its first GPS ping, your car will appear here on the map.",
    linkedAs: "Linked device",
    onbStep: "Step {n} of {total}",
    onbWelcome: "Welcome to CarTrack!",
    onbWelcomeBody: "Let's set up your account in 3 quick steps.",
    onbCarTitle: "Your car",
    onbCarBody: "Give your car a nickname and number plate.",
    numberPlate: "Number plate",
    continueLbl: "Continue",
    onbDeviceTitle: "Link your device",
    onbDeviceBody: "Enter the Device ID shown on your car's head-unit screen.",
    onbContactsTitle: "Emergency contacts (optional)",
    onbContactsBody: "Add up to 3 people who'll receive a Telegram alert if you ever tap SOS. You can add these later in Settings.",
    skipForNow: "Skip for now",
    finish: "Finish",
    tryDemo: "Try the demo account",
    forgotPassword: "Forgot Password?",
    forgotPasswordDesc: "We'll send an OTP to your email",
    sendOtp: "Send OTP",
    otpCode: "OTP Code",
    newPassword: "New Password",
    resetPassword: "Reset Password",
    otpTelegramHint: "Enter your registered email address. You will receive a 6 digit OTP.",
    continueWithGoogle: "Continue with Google",
    back: "Back",
  },
  hi: {
    appName: "कारट्रैक",
    tagline: "आपकी कार की लाइव जीपीएस ट्रैकिंग",
    login: "लॉगिन",
    signup: "साइन अप",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "नाम",
    createAccount: "खाता बनाएं",
    alreadyHave: "पहले से खाता है?",
    noAccount: "खाता नहीं है?",
    logout: "लॉगआउट",
    home: "होम",
    trips: "यात्राएँ",
    alerts: "अलर्ट",
    settings: "सेटिंग्स",
    geofences: "जिओफ़ेंस",
    connected: "कनेक्टेड",
    disconnected: "ऑफ़लाइन",
    currentSpeed: "वर्तमान गति",
    engineStatus: "इंजन स्थिति",
    moving: "चल रही है",
    parked: "रुकी हुई",
    lastUpdated: "अंतिम अपडेट",
    todayDistance: "आज की दूरी",
    recenter: "फिर से केंद्र में",
    noInternet: "इंटरनेट नहीं है",
    linkDevice: "अपनी कार डिवाइस जोड़ें",
    deviceIdHelp:
      "अपनी कार की CarTrack हेड-यूनिट स्क्रीन पर दिखाई गई डिवाइस आईडी दर्ज करें।",
    deviceId: "डिवाइस आईडी",
    carName: "कार का नाम",
    link: "डिवाइस जोड़ें",
    linked: "डिवाइस सफलतापूर्वक जुड़ गई",
    tripHistory: "यात्रा इतिहास",
    noTrips: "कोई यात्रा नहीं। ड्राइव शुरू करें।",
    duration: "अवधि",
    distance: "दूरी",
    start: "प्रारंभ",
    end: "समाप्त",
    viewRoute: "रूट देखें",
    active: "सक्रिय",
    completed: "पूर्ण",
    safeZones: "सुरक्षित ज़ोन",
    tapMapToPlace: "जिओफ़ेंस सेट करने के लिए मानचित्र पर टैप करें",
    radius: "त्रिज्या",
    save: "सहेजें",
    delete: "हटाएँ",
    noGeofences: "कोई जिओफ़ेंस नहीं।",
    noAlerts: "कोई अलर्ट नहीं।",
    overspeed: "ओवरस्पीडिंग",
    geofenceEnter: "ज़ोन में प्रवेश",
    geofenceExit: "सुरक्षित ज़ोन से बाहर",
    markRead: "पढ़ा हुआ चिह्नित करें",
    profileName: "प्रोफ़ाइल नाम",
    speedLimit: "स्पीड अलर्ट सीमा (किमी/घंटा)",
    language: "भाषा",
    english: "English",
    hindi: "हिन्दी",
    version: "ऐप संस्करण",
    signalStrength: "जीपीएस सिग्नल",
    cartrackRunning: "CarTrack चल रहा है",
    headUnit: "कार हेड यूनिट (सिम्युलेटेड)",
    copyId: "आईडी कॉपी करें",
    copied: "कॉपी हो गया!",
    welcome: "वापसी पर स्वागत है",
    getStarted: "शुरू करें",
    or: "या",
    loading: "लोड हो रहा है…",
    saved: "सहेजा गया",
    demoHint: "डेमो: demo@cartrack.in / demo1234",
    carLive: "लाइव कार लोकेशन",
    live: "लाइव",
    viewOnMap: "मानचित्र पर देखें",
    back: "वापस",
    placeGeofence: "जिओफ़ेंस रखें",
    geofenceName: "ज़ोन का नाम",
    createGeofence: "जिओफ़ेंस बनाएँ",
    unread: "अपठित",
    allAlerts: "सभी",
    speedOver: "गति",
    ignition: "इग्निशन",
    confirmDelete: "इस जिओफ़ेंस को हटाएँ?",
    yes: "हाँ",
    cancel: "रद्द करें",
    shareLive: "लाइव लोकेशन साझा करें",
    shareDesc: "15 मिनट का लिंक बनाएँ — बिना खाते के कोई भी आपकी कार देख सकेगा।",
    create15Min: "15 मिनट का लिंक बनाएँ",
    create30Min: "30 मिनट का लिंक बनाएँ",
    copyLink: "लिंक कॉपी करें",
    linkCopied: "लिंक कॉपी हो गया!",
    expiresIn: "समाप्त होगा",
    revoke: "रद्द करें",
    activeLinks: "सक्रिय लिंक",
    noActiveLinks: "कोई सक्रिय लिंक नहीं",
    sharedCar: "लाइव कार लोकेशन",
    shareExpired: "यह लिंक समाप्त हो गया है",
    linkNotFound: "लिंक नहीं मिला या अमान्य है",
    minutesShort: "मिनट",
    secondsShort: "सेकंड",
    poweredBy: "CarTrack द्वारा संचालित",
    sos: "SOS",
    sosTrigger: "SOS भेजें",
    sosConfirmTitle: "आपातकालीन SOS भेजें?",
    sosConfirmBody: "यह आपके सभी आपातकालीन संपर्कों को Telegram के माध्यम से आपके लाइव लोकेशन के साथ सूचित करेगा।",
    sosSending: "SOS भेजा जा रहा है…",
    sosSent: "{n} संपर्कों को SOS भेजा गया",
    sosNoContacts: "पहले सेटिंग्स में कम से कम एक आपातकालीन संपर्क जोड़ें।",
    sosHistory: "SOS इतिहास",
    emergencyContacts: "आपातकालीन संपर्क",
    emergencyContactsHelp: "3 संपर्क जोड़ें। SOS पर एक टैप से सभी को Telegram पर लाइव लोकेशन जाएगी।",
    contactName: "संपर्क का नाम",
    mobileNumber: "मोबाइल नंबर",
    addContact: "संपर्क जोड़ें",
    maxContactsReached: "आपने अधिकतम 3 संपर्क जोड़ लिए हैं",
    whatsappLog: "WhatsApp आउटबॉक्स (DRY RUN)",
    whatsappLogHelp: "वे संदेश जो भेजे जाते। वास्तविक WhatsApp API क्रेडेंशियल जोड़ें।",
    dryRun: "DRY RUN",
    noMessages: "अभी कोई संदेश नहीं।",
    reports: "रिपोर्ट",
    weeklyReport: "साप्ताहिक ड्राइवर रिपोर्ट",
    weekRange: "सप्ताह: {s} – {e}",
    totalDistance: "कुल दूरी",
    tripsCount: "यात्राएँ",
    overspeedEvents: "ओवरस्पीड घटनाएँ",
    topSpeed: "अधिकतम गति",
    avgSpeed: "औसत गति",
    score: "ड्राइविंग स्कोर",
    generateNow: "इस सप्ताह की रिपोर्ट बनाएँ",
    noReportsYet: "अभी कोई साप्ताहिक रिपोर्ट नहीं है। शेड्यूलर रविवार रात 9 बजे IST चलता है।",
    reportHistory: "इतिहास (पिछले 4 सप्ताह)",
    generated: "जनरेट किया गया",
    noDataWeek: "इस सप्ताह कोई ड्राइविंग नहीं",
    waitingTitle: "आपकी कार के कनेक्ट होने की प्रतीक्षा है",
    waitingBody: "जब आपकी CarTrack हेड-यूनिट पहली बार GPS भेजेगी, आपकी कार यहाँ मानचित्र पर दिखाई देगी।",
    linkedAs: "जुड़ी हुई डिवाइस",
    onbStep: "चरण {n} / {total}",
    onbWelcome: "CarTrack में आपका स्वागत है!",
    onbWelcomeBody: "3 आसान चरणों में सेटअप करें।",
    onbCarTitle: "आपकी कार",
    onbCarBody: "कार का नाम और नंबर प्लेट दर्ज करें।",
    numberPlate: "नंबर प्लेट",
    continueLbl: "आगे बढ़ें",
    onbDeviceTitle: "डिवाइस लिंक करें",
    onbDeviceBody: "अपनी कार की हेड-यूनिट स्क्रीन पर दिखाई गई डिवाइस आईडी दर्ज करें।",
    onbContactsTitle: "आपातकालीन संपर्क (वैकल्पिक)",
    onbContactsBody: "3 लोगों को जोड़ें जिन्हें SOS टैप करने पर Telegram अलर्ट मिलेगा। बाद में भी सेटिंग्स से जोड़ सकते हैं।",
    skipForNow: "अभी छोड़ें",
    finish: "समाप्त",
    tryDemo: "डेमो खाते से आज़माएँ",
    forgotPassword: "पासवर्ड भूल गए?",
    forgotPasswordDesc: "हम आपके ईमेल पर OTP भेजेंगे",
    sendOtp: "OTP भेजें",
    otpCode: "OTP कोड",
    newPassword: "नया पासवर्ड",
    resetPassword: "पासवर्ड रीसेट करें",
    otpTelegramHint: "अपना पंजीकृत ईमेल पता दर्ज करें। आपको 6 अंकों का OTP प्राप्त होगा।",
    continueWithGoogle: "Google से जारी रखें",
    back: "वापस",
  },
};
